/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue Feb 11 2025
 **/

import { ComponentType, useEffect } from "react";

import { EventHandler } from "@rfice/eventhandler";

/**
 * @requires displayName
 * @param WrappedComponent
 */
export default function withRenderDetect<T>(WrappedComponent: ComponentType<T>) {
	return function (props: React.ComponentProps<typeof WrappedComponent> & JSX.IntrinsicAttributes) {
		useEffect(() => {
			EventHandler.fire("$Detect::UIState$", { state: "mount", name: WrappedComponent.displayName });

			return () => {
				EventHandler.fire("$Detect::UIState$", { state: "unmount", name: WrappedComponent.displayName });
			};
		}, []);
		return <WrappedComponent {...props} />;
	};
}
